module.exports = __webpack_public_path__ + "static/media/01.a8f103b0.png";